module.exports = __webpack_public_path__ + "img/leftcalf-endo-mesomorph-female.dd61f593.svg";